import styled from 'styled-components';
import {bodyColorAccent} from '../../styles';

type Props = {
  tags: string[];
  size: number;
};

export function ItemTags(props: Props): JSX.Element | null {
  if (props.tags.length === 0) {
    return null;
  }

  const tagSize = Math.ceil(props.size * 0.8);

  return (
    <Container size={tagSize}>
      {props.tags.map((tag, i) => (
        <ItemTag key={`tag-${i}`} tag={tag} size={tagSize}></ItemTag>
      ))}
    </Container>
  );
}

type ItemTagProps = {
  tag: string;
  size: number;
};

function ItemTag(props: ItemTagProps): JSX.Element {
  return <Tag size={props.size}>{props.tag}</Tag>;
}

const Container = styled.div<{size: number}>`
  display: flex;
  gap: ${({size}) => `${size / 2}px`};
`;

const Tag = styled.div<{size: number}>`
  font-size: ${({size}) => `${size}px`};
  border-radius: ${({size}) => `${size}px`};
  border: 1px solid #ccc;
  padding: ${({size}) => `${size / 4}px`} ${({size}) => `${size / 2}px`};
  background-color: ${bodyColorAccent};
`;
